import { render, staticRenderFns } from "./OrderDetailPayment.vue?vue&type=template&id=76ad2492&scoped=true&"
import script from "./OrderDetailPayment.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPayment.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPayment.vue?vue&type=style&index=0&id=76ad2492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ad2492",
  null
  
)

export default component.exports